import { type PropsWithChildren } from "react";
import Anchor, { type AnchorProps } from "@/components/common/Anchor";

export type AnchorIfProps = Omit<AnchorProps, "href"> & {
  href?: string;
};

export default function AnchorIf(props: PropsWithChildren<AnchorIfProps>) {
  const { href, children, extendedURI = true, ...anchorProps } = props;

  if (href) {
    return (
      <Anchor href={href} extendedURI={extendedURI} {...anchorProps}>
        {children}
      </Anchor>
    );
  }

  const { className } = anchorProps;

  return <div className={className}>{children}</div>;
}
